/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { Presence } from "@ark-ui/react/presence";
import { PopoverContentStandalone } from "@ndla/primitives";
import { styled } from "@ndla/styled-system/jsx";

export const MastheadPopoverContent = styled(PopoverContentStandalone, {
  base: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxWidth: "[calc(token(sizes.surface.pageMax) + 2 * token(spacing.xxlarge))]",
    maxHeight: "[calc(100vh - var(--masthead-height))]",
    overflow: "auto",
    position: "absolute",
    left: "0",
    right: "0",
    marginInline: "auto",
    top: "var(--masthead-height)",
    padding: "0",
    borderRadius: "sharp",
    tabletWide: {
      flexDirection: "row",
    },
  },
});

export const MastheadPopoverBackdrop = styled(
  Presence,
  {
    base: {
      position: "absolute",
      top: "var(--masthead-height)",
      overflow: "hidden",
      left: "0",
      zIndex: "[-1]",
      width: "full",
      height: "[100vh]",
      background: "[rgba(1, 1, 1, 0.3)]",
      _open: {
        animation: "backdrop-in",
        _motionReduce: {
          animation: "[none]",
        },
      },
      _closed: {
        animation: "backdrop-out",
        _motionReduce: {
          animation: "[none]",
        },
      },
    },
  },
  { baseComponent: true },
);
